import { driver, DriveStep } from 'driver.js';
import 'driver.js/dist/driver.css';
import { baseTourConfig, injectTourStyles } from './tourConfig';
import { TourId } from '@/store/tourStore';
import { TENANT_ROOT_DOMAIN } from '@staty/shared/domains';

export const TOUR_ID: TourId = 'view-site';

export const createSteps = (navigate: (path: string) => void): DriveStep[] => [
  {
    popover: {
      title: 'View Your League Site',
      description: 'Your league has a public website where players and teams can see schedules, standings, and register. Let\'s explore how to view and customize it!',
      side: 'over',
      align: 'center',
    },
  },
  {
    element: '[data-tour="nav-view-site"]',
    popover: {
      title: 'Visit League Site',
      description: 'Click here to open your public league website in a new tab. This is what players and teams will see when they visit your league.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="nav-layout-editor"]',
    popover: {
      title: 'Customize Your Site',
      description: 'Use the Layout Editor to customize your league\'s home page. Add announcements, update content, and make your site look professional.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '[data-tour="nav-settings"]',
    popover: {
      title: 'League Settings',
      description: 'Update your league banner, name, description, and other branding settings here. Make your league site uniquely yours!',
      side: 'right',
      align: 'start',
    },
  },
  {
    popover: {
      title: 'Share Your League',
      description: `Your league URL is: yourleague.${TENANT_ROOT_DOMAIN}. Share this link with teams, players, and fans to access schedules, standings, and registration!`,
      side: 'over',
      align: 'center',
    },
  },
];

export const startViewSiteTour = (onComplete?: () => void, navigate?: (path: string) => void) => {
  injectTourStyles();

  const steps = createSteps(navigate || (() => {}));
  
  const driverObj = driver({
    ...baseTourConfig,
    steps,
    onDestroyStarted: () => {
      onComplete?.();
      driverObj.destroy();
    },
  });

  driverObj.drive();
  return driverObj;
};
